import PrivatePolicyView from "../views/PrivatePolicyView.vue";

export const PrivatePolicyRouters = [
    {
        path: "/privatePolicy",
        name: "PrivatePolicyView",
        components: {
            default: PrivatePolicyView,
        },
    },
];
